import { Combobox } from '@library/components/selects/combobox/Combobox';
import type { ComboboxOption } from '@library/components/selects/combobox/Combobox';

export interface GameModesComboboxProps {
  id?: string;
  label?: string;
  onChange: (value: Array<ComboboxOption> | null) => void;
  options: Array<ComboboxOption>;
  placeholder?: string;
  value: Array<ComboboxOption> | null;
}

export const GameModesCombobox = ({
  id = 'GameModes',
  label = 'Game Modes',
  onChange,
  options,
  placeholder = 'Select Game Modes...',
  value
}: GameModesComboboxProps) => {
  return (
    <Combobox
      allowSelectAll
      id={id}
      isClearable
      isMulti
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
      value={value}
    />
  );
};
